var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H47V47H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.385 46.69H16.56L18.966 32.232H22.79L20.385 46.69ZM13.327 32.232L9.66 42.167L9.227 40.041L7.925 33.508C7.925 33.508 7.768 32.193 6.112 32.193H0.079L0 32.463C0 32.463 1.853 32.85 4.022 34.126L7.373 46.691H11.356L17.467 32.231L13.327 32.232ZM43.49 46.69H47L43.925 32.232H40.849C39.429 32.232 39.075 33.314 39.075 33.314L33.397 46.691H37.379L38.168 44.526H43.058L43.491 46.691L43.49 46.69ZM39.272 41.549L41.282 36.137L42.426 41.549H39.272ZM33.673 35.711L34.225 32.618C34.225 32.618 32.529 32 30.755 32C28.863 32 24.328 32.812 24.328 36.794C24.328 40.544 29.651 40.583 29.651 42.554C29.651 44.526 24.881 44.178 23.303 42.941L22.751 46.188C22.751 46.188 24.446 47 27.088 47C29.691 47 33.673 45.686 33.673 42.051C33.673 38.301 28.31 37.954 28.31 36.291C28.31 34.591 32.017 34.822 33.673 35.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.227 40.003L7.925 33.508C7.925 33.508 7.768 32.193 6.112 32.193H0.079L0 32.463C0 32.463 2.918 33.043 5.678 35.286C8.359 37.374 9.227 40.003 9.227 40.003Z",
    fill: "#FAA634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.313 2.78H17.686V23.22H29.313V2.78Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.425 13C18.425 8.847 20.418 5.164 23.482 2.78C21.1335 0.972179 18.2517 -0.00554481 15.288 5.71166e-07C7.942 5.71166e-07 2 5.814 2 13C2 20.186 7.942 26 15.288 26C18.388 26 21.23 24.953 23.482 23.22C21.9111 22.019 20.6379 20.4724 19.7609 18.7001C18.884 16.9278 18.4269 14.9774 18.425 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 13C45 20.186 39.058 26 31.713 26C28.7493 26.0057 25.8674 25.028 23.519 23.22C26.619 20.836 28.575 17.153 28.575 13C28.575 8.847 26.582 5.164 23.519 2.78C25.8674 0.97211 28.7493 -0.00562165 31.713 -6.94399e-07C39.058 -6.94399e-07 45 5.85 45 13Z",
    fill: "#F79E1B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.941b4bc747288b82ad4e06cd05379526.svg";
export { ForwardRef as ReactComponent };